import { createStateTag } from 'components/StateTag';
import { TicketState } from './types';

export const TickStateTag = createStateTag<TicketState>({
  testId: 'ticket-state-tag',
  stateVariantMap: {
    OPEN: { icon: 'play', variant: 'warning' },
    CLOSED: { icon: 'circle-check', variant: 'success' },
    CANCELED: { icon: 'circle-xmark', variant: 'secondary' },
  },
});
